<template>
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <h4 class="page-title float-left">特许私人财富管理师报名考试</h4>
                                          
                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                <li class="breadcrumb-item active">首次认证</li>
                                          </ol>
                                          
                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                        
                        
                        <div class="row">
                              <div class="col-md-12">
                                    <div class="card-box">
                                          <div class="row">
                                                <div class="col-12">
                                                      
                                                      
                                                      <h1 class="display-1">{{title}}</h1>
                                                      <p class="text-muted">{{content}}</p>
                                                      
                                                      <div class="clearfix"></div>
                                                
                                                
                                                </div>
                                          
                                          </div>
                                          
                                          
                                          <!-- end row -->
                                    
                                    </div>
                              </div>
                        
                        </div>
                        <!-- end row -->
                  
                  
                  </div> <!-- container -->
            
            </div> <!-- content -->
      
            <!--footer-->
      
      </div>
      </div>

</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'main',
            components:{topbar,left},
            data(){
                  return{
                        id:this.$route.params.id,
                        title:this.title,
                        content:this.content,
                  }
            },
            mounted(){
                  this.show();
            },
            methods:{
                  show: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/msg_show?id='+this.id,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.title = response.data.title;
                              this.content = response.data.content;
                              

                        }.bind(this)).catch(function OnError() {

                        })

                  },
            },
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/msg_show.vue